
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */
import Playground from '@ecl/website-components/Playground';
import Tag from '@ecl/ec-react-component-tag';

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <h2>{`Link`}</h2>
    <p>{`When the click on the tag leads to another page.`}</p>
    <Playground system="ec" selectedKind="components-tag" selectedStory="as-a-link" mdxType="Playground">
  <Tag label="Link tag" href="/example" mdxType="Tag" />
    </Playground>
    <h2>{`Removable`}</h2>
    <p>{`When using the `}<inlineCode parentName="p">{`removable`}</inlineCode>{` variant, the tag gets a "Remove" icon. It can be either a button or a link, dependening on your need.`}</p>
    <Playground system="ec" selectedKind="components-tag" selectedStory="removable" mdxType="Playground">
  <Tag label="Removable tag" variant="removable" dismissButtonLabel="Dismiss" mdxType="Tag" />
    </Playground>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;